module.exports = __webpack_public_path__ + "pc/img/about_sensibility.9fa6a159.png";